<template>
    <transition name="modal-fade">
        <div class="modal-backdrop">
            <div class="modal"
                 v-bind:style="style"
                 role="dialog"
                 aria-labelledby="modalTitle"
                 aria-describedby="modalDescription"
            >
                <header
                    class="modal-header"
                    id="modalTitle"
                >
                    <slot name="header">
                        <h3>{{ componentTitle }}</h3>
                    </slot>
                    <button
                        type="button"
                        class="btn-close"
                        @click="close"
                        aria-label="Close modal"
                    >
                        x
                    </button>
                </header>

                <section
                    class="modal-body"
                    id="modalDescription"
                >
                    <slot name="body">
                        <component
                            :is="component.type"
                            :config="component"
                            :index="0"
                            :moduleConfig="{}"
                            :eventBus="eventBus"
                            :extraData="component.extraData"
                            :emitEvents="component.emitEvents"
                        ></component>
                    </slot>
                </section>
            </div>
        </div>
    </transition>
</template>

<script>

import formComponent from "../../components/FormComponent";
import grid from "../../components/Grid";
import dynamicPricingRuleExpert from "../../components/DynamicPricingRuleExpertComponent";
import dynamicPricingRule from "../../components/DynamicPricingRuleComponent";
import chartRadar from "../../components/ChartRadarComponent";

export default {
    components: {formComponent, grid, dynamicPricingRuleExpert, dynamicPricingRule, chartRadar},
    name: 'Modal',
    props: {
        eventBus: {
            Type: Object,
        },
    },
    data() {
        return {
            component: {},
            componentTitle: '',
            events: [],
            style: {}
        }
    },
    methods: {
        close() {
            this.$emit('close');
            this.unmountEvents();
            this.component = {};
        },
        unmountEvents() {
            this.events.forEach(e => {
                this.eventBus.$off(e);
            });
        },
    },
    mounted() {
        this.eventBus.$on('close-modal', () => {
            this.close();
        });

        this.eventBus.$on('init-modal', (config, data) => {
            let componentIndex = config.componentIndex;
            let componentService = this.eventBus.getComponentService();
            let componentConfig = componentService.get(componentIndex).getConfig();

            this.style = 'style' in componentConfig ? componentConfig.style : {};
            this.componentTitle = componentConfig.title;
            delete componentConfig.title;
            componentConfig.extraData = data.data;
            this.component = componentConfig;

            setTimeout(() => {
                let customModuleEventName = `modal:ready`;
                this.eventBus.$emit('CustomModule:ready', customModuleEventName, 'modal');
                this.events.push('CustomModule:ready');

                this.eventBus.$emit(customModuleEventName, componentConfig, data.data);
                this.events.push(customModuleEventName);

                config.callback();
            }, 1000);
        });
    },
};
</script>

<style lang="sass" scoped>
@import "src/assets/scss/variable.scss";

.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    left: auto;
    right: auto;
    width: 40%;
    min-width: 500px;
    margin: 150px;
}

.modal-header,
.modal-footer {
    padding: 15px;
    display: flex;
}

.modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: $main-background-color;
    justify-content: space-between;
}

.modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
}

.modal-body {
    position: relative;
    padding: 20px 10px;
    overflow: auto;
}

.btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
}

.btn-green {
    color: white;
    background: $main-background-color;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
}

.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .5s ease;
}
</style>


// WEBPACK FOOTER //
// Modal.vue?329da204